'use client';

import dynamic from 'next/dynamic';

const AltchaWidgetInner = dynamic(() => import('./altcha-widget-inner'), { ssr: false });

const AltchaWidget: React.FC = () => <AltchaWidgetInner />;

export default AltchaWidget;
